import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7f41267f"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "header" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "Search", -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Your notes at your fingertips", -1));
const _hoisted_5 = {
    ref: "sliderParent",
    class: "input-container"
};
const _hoisted_6 = {
    key: 0,
    class: "loading"
};
const _hoisted_7 = {
    key: 1,
    class: "results"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_button = _resolveComponent("el-button");
    const _component_el_input = _resolveComponent("el-input");
    const _component_el_skeleton = _resolveComponent("el-skeleton");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_input, {
                    modelValue: $setup.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.value) = $event)),
                    placeholder: "Type something",
                    onKeydown: $setup.handleKeydown
                }, {
                    append: _withCtx(() => [
                        _createVNode(_component_el_button, {
                            type: "primary",
                            icon: $setup.Search,
                            onClick: $setup.handleChange
                        }, null, 8, ["icon", "onClick"])
                    ]),
                    _: 1
                }, 8, ["modelValue", "onKeydown"])
            ], 512)
        ]),
        ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_el_skeleton, {
                    rows: 3,
                    animated: ""
                }),
                _createVNode(_component_el_skeleton, {
                    rows: 3,
                    animated: ""
                }),
                _createVNode(_component_el_skeleton, {
                    rows: 3,
                    animated: ""
                })
            ]))
            : _createCommentVNode("", true),
        ($setup.notes.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.notes, (note) => {
                    return (_openBlock(), _createElementBlock("div", {
                        onClick: ($event) => ($setup.choose(note)),
                        key: note.id,
                        class: "note-item"
                    }, [
                        _createElementVNode("div", {
                            class: "content",
                            innerHTML: note.content
                        }, null, 8, _hoisted_9)
                    ], 8, _hoisted_8));
                }), 128))
            ]))
            : _createCommentVNode("", true)
    ]));
}
